import { Component, Input, OnChanges, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationSummaryComponent } from '../application-program-summary/application-program-summary.component';

@Component({
    selector: 'app-program-info-modal',
    templateUrl: './program-info-modal.component.html',
    styleUrls: ['./program-info-modal.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, ApplicationSummaryComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProgramInfoModalComponent implements OnChanges {
    @Input() program: any;
    @Input() user: any;

    constructor(private modalCtrl: ModalController) {}

    ngOnChanges() {
        /* empty */
    }

    dismiss() {
        this.modalCtrl.dismiss({
            result: false,
        });
    }
}
